/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import { classNames } from '../../../utils';
import { INotificationProps, Variant, Position } from '../types';
import { ErrorIcon, InfoIcon, SuccessIcon, CrossIcon } from '../assets';

const VARIANT_MAP: Record<Variant, string> = {
  [Variant.ERROR]: 'bg-red-light border-red text-red',
  [Variant.INFO]: 'bg-blue-light border-blue text-blue',
  [Variant.SUCCESS]: 'bg-green-light border-green text-green',
};

const POSITION_MAP: Record<Position, string> = {
  [Position.BOTTOM_LEFT]: 'animate-in-from-right',
  [Position.TOP_LEFT]: 'animate-in-from-right',
  [Position.BOTTOM_RIGHT]: 'animate-in-from-left',
  [Position.TOP_RIGHT]: 'animate-in-from-left',
  [Position.TOP_CENTER]: '',
  [Position.BOTTOM_CENTER]: '',
};

const ICON_MAP: Record<Variant, JSX.Element> = {
  [Variant.ERROR]: <ErrorIcon />,
  [Variant.INFO]: <InfoIcon />,
  [Variant.SUCCESS]: <SuccessIcon />,
};

const Notification = ({
  variant = 'INFO',
  content,
  children,
  position,
  transitionDuration,
  transitionState,
  onMouseEnter,
  onMouseExit,
  onDismiss,
}: INotificationProps) => {
  const [height, setHeight] = useState<string | number>('auto');
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (transitionState === 'entered') {
      const el = elementRef.current;
      if (el) setHeight(el.offsetHeight);
    }
    if (transitionState === 'exiting') {
      setHeight(0);
    }
  }, [transitionState]);

  return (
    <div
      ref={elementRef}
      style={{
        height,
        transition: `height ${transitionDuration - 100}ms 100ms`,
      }}
      className={classNames('p-2', POSITION_MAP[position])}
    >
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseExit}
        className={classNames(
          VARIANT_MAP[Variant[variant]],
          'relative overflow-hidden shadow opacity-90 p-4 rounded-md border w-notification text-sm',
        )}
      >
        <div className='flex flex-row items-center jsutify-start space-x-4'>
          <div>{ICON_MAP[Variant[variant]]}</div>

          <div className='flex flex-col items-start space-y-1 flex-1'>
            {content.title ? (
              <p className='text-gray-darkest font-semibold'>{content.title}</p>
            ) : (
              <p className='text-gray-darkest font-semibold'>
                Your Attention Is Needed
              </p>
            )}
            <p className='font-normal'>{content.description}</p>
            {children}
          </div>

          {onDismiss ? (
            <div
              role='button'
              className='w-6 h-6 outline-none border-none focus:outline-none cursor-pointer '
              onClick={onDismiss}
            >
              <CrossIcon width='18px' height='18px' strokeWidth='1' />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Notification;
